import { useSelector, useDispatch } from 'react-redux';
import TreeView from "../Rules/TreeView";
import {getRuleById, initializeAuth} from "../../services/apiService";
import { setSelectedPart } from '../../redux/rulesSlice';
import { useMsal } from "@azure/msal-react";
import Assemblies from './Assemblies';
import Parts from './Parts';

export const PartTree = () => {
  const { instance, accounts } = useMsal();
  const { cacheTab } = useSelector(state => state.rules);
  const dispatch = useDispatch();

 const handleItemSelect = async (item) => {
       dispatch(setSelectedPart(item));
  };
  return (
    <div className="h-screen overflow-y-auto bg-white">
      {cacheTab === 'assemblies' && <Assemblies onItemSelect={(item) => handleItemSelect(item)} /> }
      {cacheTab === 'parts' && <Parts onItemSelect={(item) => handleItemSelect(item)} /> }
    </div>    
  ) 
};
